<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">Today’s Top Performing Agents</h3>
      </div>
      <section class="pt-5">
        <div>
          <b-tabs active-nav-item-class="top-agent-active" content-class="mt-3">
            <b-tab class="pl-0" title="Pinpad Transactions">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topPinpadEntries"
                ></b-form-select>
                <span slot="entries-no"
                  >of {{ topPinpadEntries.length }} entries</span
                >
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="isBusyPinpad"
                  :items="topPinpadData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </TopAgentsTable>
            </b-tab>
            <b-tab title="POS Transactions">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topPosEntries"
                ></b-form-select>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="isBusyPos"
                  :items="topPosData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </TopAgentsTable>
            </b-tab>
            <!-- <b-tab title="Transfer">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topTransferEntries"
                ></b-form-select>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="isBusyTransfer"
                  :items="topTransferData"
                ></b-table>
              </TopAgentsTable>
            </b-tab> -->
            <b-tab title="Account Opening">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topAccountEntries"
                ></b-form-select>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="isBusyAccount"
                  :items="topAccountData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </TopAgentsTable>
            </b-tab>
          </b-tabs>
        </div>
      </section>
    </Layout>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TopAgentsTable from "@/components/TopAgentsTable.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "TopAgents",
  components: {
    Loading,
    Layout,
    TopAgentsTable,
  },
  data() {
    return {
      today: moment(Date.now()).format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.topAgents.initialLoad,
      loading: (state) => state.topAgents.loading,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      isBusyPinpad: (state) => state.topAgents.topPinpad.busy,
      isBusyPos: (state) => state.topAgents.topPos.busy,
      isBusyTransfer: (state) => state.topAgents.topTransfer.busy,
      isBusyAccount: (state) => state.topAgents.topAccount.busy,

      topPinpadData: (state) => {
        if (state.topAgents.topPinpad.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topPinpad.data;
        }
      },
      topPinpadEntries: (state) => {
        if (state.topAgents.topPinpad.data > 0) {
          return [...state.topAgents.topPinpad.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
      topPosData: (state) => {
        if (state.topAgents.topPos.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topPos.data;
        }
      },
      topPosEntries: (state) => {
        if (state.topAgents.topPos.data > 0) {
          return [...state.topAgents.topPos.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
      topTransferData: (state) => {
        if (state.topAgents.topTransfer.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topTransfer.data;
        }
      },
      topTransferEntries: (state) => {
        if (state.topAgents.topTransfer.data > 0) {
          return [...state.topAgents.topTransfer.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
      topAccountData: (state) => {
        if (state.topAgents.topAccount.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topAccount.data;
        }
      },
      topAccountEntries: (state) => {
        if (state.topAgents.topAccount.data > 0) {
          return [...state.topAgents.topAccount.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      topPinpad: "topAgents/getTopPinpad",
      topPos: "topAgents/getTopPos",
      topTransfer: "topAgents/getTopTransfer",
      topAccount: "topAgents/getTopAccount",
    }),
  },
  created() {
    document.title = "Top Agents | ReadyCash Aggregator Portal";
    this.topPinpad({
      startDate: this.today,
      endDate: this.today,
    });
    this.topPos({
      startDate: this.today,
      endDate: this.today,
    });
    this.topTransfer({
      startDate: this.today,
      endDate: this.today,
    });
    this.topAccount({
      startDate: this.today,
      endDate: this.today,
    });
  },
};
</script>

<style></style>
